module.exports = __webpack_public_path__ + "static/media/gunjan.ffd312b4.jpg";